export const keyFactory = {
  getCategoryHomePage: 'getCategoryHomePage',
  getProductCategory: 'getProductCategory',
  getEncryptQuery: 'getEncryptQuery',
  getRecentChanges: 'getRecentChanges',
  getRecentAlert: 'getRecentAlert',
  getAnnouncement: 'getAnnouncement',
  getAnnouncementPopups: 'getAnnouncementPopups',
  getRecentAlertContent: 'getRecentAlertContent',
  getRecentChangesContent: 'getRecentChangesContent',
  getHamburgerMenuOptions: 'getHamburgerMenuOptions',
  getFindGrids: 'getFindGrids',
  getViewGridDetails: 'getViewGridDetails',
  getOutstandingReviews: 'getOutstandingReviews',
  getMoreOption: 'getMoreOption',
  getSRDisplayConfig: 'getSRDisplayConfig',
  getReportRelatedLink: 'getReportRelatedLink',
  getReportRelatedAlerts: 'getReportRelatedAlerts',
  getReportAnalysisOverview: 'getReportAnalysisOverview',
  getSingleReport: 'getSingleReport',
  getCompareSingleReport: 'getCompareSingleReport',
  getOpinionContentTileId: 'getOpinionContentTileId',
  getReportRelatedTools: 'getReportRelatedTools',
  getBlendedAvailableProduct: 'getBlendedAvailableProduct',
  getOpinionQuestion: 'getOpinionQuestion',
  getColorOptions: 'getColorOptions',
  getReportTemplates: 'getReportTemplates',
  getReportResponseType: 'getReportResponseType',
  getAnswerResponseType: 'getAnswerResponseType',
  getTreeType: 'getTreeType',
  getFactPattern: 'getFactPattern',
  getGrayOutResponse: 'getGrayOutResponse',
  getFileTypeDetails: 'getFileTypeDetails',
  getDecryptEurl: 'getDecryptEurl',
  getJurisdictionsAllowance: 'getJurisdictionsAllowance',
  getProductAccess: 'getProductAccess',
  getQuestionExistInTemplate: 'getQuestionExistInTemplate',
  getSingleReportComment: 'getSingleReportComment',
  getEffectiveDate: 'getEffectiveDate',
  getVersion: 'getVersion',
  getContactDetails: 'getContactDetails',
  getGuidanceDetails: 'getGuidanceDetails',
  getResourcesDetails: 'getResourcesDetails',
  getCounterpartyVersionCompare: 'getCounterpartyVersionCompare',
  getGuidanceAttachment: 'getGuidanceAttachment',
  getResourcesAttachment: 'getResourcesAttachment',
  getJurisdictionsLimitModal: 'getJurisdictionsLimitModal',
  getEntities: 'getEntities',
  getPinnedDocument: 'getPinnedDocument',
  getEditorialPageContent: 'getEditorialPageContent',
  getEditorialPageImpectDataWhatsNew: 'getEditorialPageImpectDataWhatsNew',
  getPageDetails: 'getPageDetails',
  getAuthorDetailsPage: 'getAuthorDetailsPage',
  getAlertRenderingStyle: 'getAlertRenderingStyle',
  getAlertTags: 'getAlertTags',
  getAlertJurisdictions: 'getAlertJurisdictions',
  getAllAlerts: 'getAllAlerts',
  getProducts: 'getProducts',
  getReportComments: 'getReportComments',
  getAlertAndRelatedLinksLayout: 'getAlertAndRelatedLinksLayout',
  getAgreementTypesXml: 'getAgreementTypesXml',
  getCounterpartyTypesXml: 'getCounterpartyTypesXml',
  getJurisdictions: 'getJurisdictions',
  getReportDetails: 'getReportDetails',
  getProductDetails: 'getProductDetails',
  getResponseDocTypeList: 'getResponseDocTypeList',
  getAnalysisNodes: 'getAnalysisNodes',
  getReportTags: 'getReportTags',
  getMasterTemplates: 'getMasterTemplates',
  getTemplateQuestions: 'getTemplateQuestions',
  getTreeTypeQuestionsXml: 'getTreeTypeQuestionsXml',
  getGuests: 'getGuests',
  getReportVersionHistory: 'getReportVersionHistory',
  getVersionHistoryProductName: 'getVersionHistoryProductName',
  getVersionHistoryOpinionName: 'getVersionHistoryOpinionName',
  getVersionHistoryCommentModal: 'getVersionHistoryCommentModal',
  getOpinionVersionDefinition: 'getOpinionVersionDefinition',
  getBlendedProductRedirect: 'getBlendedProductRedirect',
  getPageTemplateTopBanner: 'getPageTemplateTopBanner',
  getPageVersionHistory: 'getPageVersionHistory',
  getPageVersionHistoryCommentModal: 'getPageVersionHistoryCommentModal',
  getPageDetailsForVersionCompare: 'getPageDetailsForVersionCompare',
  getPageVersion: 'getPageVersion',
  getAnalysisOverview: "getAnalysisOverview",
  getPageRelatedAlerts: "getPageRelatedAlerts",
  getGridVersionHistory: "getGridVersionHistory",
  getGridVersionHistoryCommentModal: "getGridVersionHistoryCommentModal",
  getCounterPartyResponseExists: "getCounterPartyResponseExists",
  getReportOverview: "getReportOverview",
  getReportAnalysis: "getReportAnalysis",
  getAnalysisDetails: "getAnalysisDetails",
  getOpinionAccess: "getOpinionAccess",
  getExportToExcelView: "getExportToExcelView",
  getExportToXMl: "getExportToXMl",
  getGridExportToExcelAccess: "getGridExportToExcelAccess",
  getGridExportToPdfAccess: "getGridExportToPdfAccess",
  getPageMoreOptions: "getPageMoreOptions",
  alertImpacts: "alertImpacts",
  getReportingReviewerUsers: "getReportingReviewerUsers",
  getReportingProducts: "getReportingProducts",
  getAllReporting: "getAllReporting",
  getReportingJurisdictions: "getReportingJurisdictions",
  getSpeedPageQuestion: "getSpeedPageQuestion",
  getPageTemplateChildResponse: "getPageTemplateChildResponse",
  getPageTemplateTopicStyle: "getPageTemplateTopicStyle",
  getPageTemplateAnswerViewType: "getPageTemplateAnswerViewType",
  getPageTemplateComplexity: "getPageTemplateComplexity",
  getAdvancedDisplayConfig: "getAdvancedDisplayConfig",
  getQuestionResponseTypeCounts: "getQuestionResponseTypeCounts",
  getCategoryByPageId: "getCategoryByPageId",
  getEditorialPageDetails: "getEditorialPageDetails",
  getAdvancedDisplayConfigUsedFor: "getAdvancedDisplayConfigUsedFor",
  getContentTileBehaviourType: "getContentTileBehaviourType",
  getEditorialPageData: "getEditorialPageData",
  getJurisdictionNameForOpinionCompare: "getJurisdictionNameForOpinionCompare",
  getReportDocuments: "getReportDocuments",
  getAlertTagDisplaySetting: "getAlertTagDisplaySetting",
  getGridUrl: "getGridUrl",
  getReportQuestion: "getReportQuestion",
  getReportQuestionAnswer: "getReportQuestionAnswer",
  getGridListUrl: "getGridListUrl",
  getGridDisplayType: "getGridDisplayType",
  getSelectedColumn: "getSelectedColumn",
  getJurisdictionDefinitions: "getJurisdictionDefinitions",
  getGridRowStyleArrayQuery: "getGridRowStyleArrayQuery",
  getGridReportDataPrint: "getGridReportDataPrint",
  getPart4FullGrid: "getPart4FullGrid",
  getGridColumnsTitles: "getGridColumnsTitles",
  getStorage: "getStorage",
  getQuestionReference: "getQuestionReference",
  getCategoryDetailsByOpinionId: "getCategoryDetailsByOpinionId",
  getBookmarkedDetails: "getBookmarkedDetails",
  getGridBookmarkStatus: "getGridBookmarkStatus",
  getCKEditorDefinationList: "getCKEditorDefinationList",
  getReportVersionDefinitionData: "getReportVersionDefinitionData",
  getReportVersionDefinitionDataById: "getReportVersionDefinitionDataById",
  getAlertSourceDate: "getAlertSourceDate",
  getAlertTagsData: "getAlertTagsData",
  getPageAdvancedDisplayConfig: "getPageAdvancedDisplayConfig",
  getPageContentTiles: "getPageContentTiles",
  getOpinionByProIdJuriId: "getOpinionByProIdJuriId",
  getPageAlertTagsData: "getPageAlertTagsData",
  getFindReportsFilters: "getFindReportsFilters",
  getAuthorDetails: "getAuthorDetails",
  getAuthorAutosuggest: "getAuthorAutosuggest",
  getAddresseeAutosuggest: "getAddresseeAutosuggest",
  checkReportIdRefExists: "checkReportIdRefExists",
  getOpinionVersionDefinationDescription: "getOpinionVersionDefinationDescription",
  getProductPreferences: "getProductPreferences",
  getDecryptString: "getDecryptString",
  getClearCache: "getClearCache",
  getGridCategory: "getGridCategory",
  getReportReferenceAlerts: "getReportReferenceAlerts",
  getDownloadPdf: "getDownloadPdf",
  getDownloadResource: "getDownloadResource",
  getViewCkEditorDocument: "getViewCkEditorDocument",
  getValidUserAccessProduct: "getValidUserAccessProduct",
  getReportDetailsPart4: "getReportDetailsPart4",
  getPageCopy: "getPageCopy",
  getDraftPageInfoData: "getDraftPageInfoData",
  getGridPropertyDetails: "getGridPropertyDetails",
  getGridDetails: "getGridDetails",
  getGridColumnTitles: "getGridColumnTitles",
  getGridFilters: "getGridFilters",
  checkOldDocLinks: "checkOldDocLinks",
  getJurisdictionDefinitionsPage: "getJurisdictionDefinitionsPage",
  getGridRowCount: "getGridRowCount",
  getGridColumnDataTypes: "getGridColumnDataTypes",
  getGridColumnDateFormats: "getGridColumnDateFormats",
  getGridTextAlignTypes: "getGridTextAlignTypes",
  getGridRowWithOtherGridRefs: "getGridRowWithOtherGridRefs",
  getGridLiveGridDetails: 'getGridLiveGridDetails',
  getGridContentConfigs: 'getGridContentConfigs',
  getGridContentTypes: 'getGridContentTypes',
  getGridStyles: 'getGridStyles',
  getGridPicklistValues: 'getGridPicklistValues',
  getGridRowStyles: 'getGridRowStyles',
  getGridCellBackgrounds: 'getGridCellBackgrounds',
  getGridColumnHighlights: 'getGridColumnHighlights',
  getGridReportDataPrintV2: "getGridReportDataPrintV2",
  getGridFirstRow: "getGridFirstRow",
  getGridRowSummaries: "getGridRowSummaries",
  getGridCellComment: "getGridCellComment",
  getGridCell: "getGridCell",
  getGridRowFirstColumn: "getGridFirstColumn",
  getGridRowFirstColumnCellDetail: "getGridFirstColumnCellDetail",
  getGridColumns: "getGridColumns",
  getGridOverviewPart2: "getGridOverviewPart2",
  getGridProductDetails: "getGridProductDetails",
  getAllInternalContacts: "getAllInternalContacts",
  getAllInternalGuidances: "getAllInternalGuidances",
  getBannerImage: "getBannerImage",
  getAllInternalResource: "getAllInternalResource",
  getAllInternalReference: "getAllInternalReference",
  getGridFilterBannerImages: "getGridFilterBannerImages",
  getOrganisationJurisdictions: 'getOrganisationJurisdictions',
  getGridTags: 'getGridTags',
  getAlertPreview: 'getAlertPreview',
  getAlertJurisdictionCheck: 'getAlertJurisdictionCheck',
  getReportNodesDetails: 'getReportNodesDetails',
  getProductBanner: 'getProductBanner',
  getPageParentQuestions: "getPageParentQuestions",
  getAssociatedQuestionPages: "getAssociatedQuestionPages",
  getPageTopicAllAnswerViewTypes: "getPageTopicAllAnswerViewTypes",
  getPageTopicAnswerViewType: "getPageTopicAnswerViewType",
  getAllBackgroundColors: "getAllBackgroundColors",
  getAllQuestionTypes: "getAllQuestionTypes",
  getQuestionSearch: "getQuestionSearch",
  getCkEditorAttachments: "getCkEditorAttachments",
  getParentQuestions: "getParentQuestions",
  getGridDocuments: "getGridDocuments",
  getGridRefExists: "getGridRefExists",
  getGridProductOrganisations: "getGridProductOrganisations",
  getGridCategoryNames: 'getGridCategoryNames',
  getPageTemplateColorOptions: 'getPageTemplateColorOptions',
  getGridSupportingGrids: "getGridSupportingGrids",
  getTopBannerImageLibrary: "getTopBannerImageLibrary",
  getGuestUsers: "getGuestUsers",
  getGridColumnMinDisplayOrder: 'getGridColumnMinDisplayOrder',
  getGridRowDataPart2: 'getGridRowDataPart2',
  getGridDataTypes: 'getGridDataTypes',
  getGridList: 'getGridList',
  getGridColumnCount: 'getGridColumnCount',
  getGridColumnData: 'getGridColumnData',
  getGridDateFormats: 'getGridDateFormats',
  getGridColumnPicklistGroup: 'getGridColumnPicklistGroup',
  getGridColumnPicklistGroupPart2: 'getGridColumnPicklistGroupPart2',
  getGridColumnOtherGrid: 'getGridColumnOtherGrid',
  getGridColumnContentOtherGrid: 'getGridColumnContentOtherGrid',
  getGridColumnContentFormatsByDataType: 'getGridColumnContentFormatsByDataType',
  getLatestEditorialPageId: 'getLatestEditorialPageId',
  getLatestReportId: 'getLatestReportId',
  getGridPicklistGroupPart2: 'getGridPicklistGroupPart2',
  getGridPicklistGroupValueIds: 'getGridPicklistGroupValueIds',
  getGridPicklistRefs: 'getGridPicklistRefs',
  getGridProducts: 'getGridProducts',
  getGridAccess: 'getGridAccess',
  getGridPropertyValuesConfig: 'getGridPropertyValuesConfig',
  getGridRowData: 'getGridRowData',
  getGridProductColorOptions: 'getGridProductColorOptions',
  getGridOverview: 'getGridOverview',
  getGridFirstColumn: "getGridColumn",
  getRegionDataByJuriId: 'getRegionDataByJuriId',
  getPostHogFlag: 'getPostHogFlag',
  getFreeTrialDetails: 'getFreeTrialDetails',
  getGridRowEditModeData: 'getGridRowEditModeData',
  getGridCellValues: 'getGridCellValues',
  getFirstColumnHyperLinkPart3: 'getFirstColumnHyperLinkPart3',
  getOtherGridCellValues: 'getOtherGridCellValues',
  getPicklistCellValues: 'getPicklistCellValues',
  getJurisdictionCellValues: 'getJurisdictionCellValues',
  getFirstColumnJurisdictionRefs: 'getFirstColumnJurisdictionRefs',
  getSelectedGrids: 'getSelectedGrids',
  getSelectedRows: 'getSelectedRows',
  getSelectedPicklists: 'getSelectedPicklists',
  getColumnDataPart3: 'getColumnDataPart3',
  getGridLiveDetails: 'getGridLiveDetails',
  getGridDefinitionData: 'getGridDefinitionData',
  getGridDocumentData: 'getGridDocumentData',
  getOpinionDocumentDetails: 'getOpinionDocumentDetails',
  getPageDocumentDetails: 'getPageDocumentDetails',
  getGridColumnComments: 'getGridColumnComments',
  getSupportingGridColumnPart3: 'getSupportingGridColumnPart3',
  getNumbersCellValues: 'getNumbersCellValues',
  getDateCellValues: 'getDateCellValues',
  getGridTotalRowCountColumnWise: 'getGridTotalRowCountColumnWise',
  getGridFormat: 'getGridFormat',
  getGridColumnContentFormats: 'getGridColumnContentFormats',
  getBulkOperationRowData: 'getBulkOperationRowData',
  getMainGridListPart3: 'getMainGridListPart3',

  // Private Banking
  getBankDomicile: 'getBankDomicile',
  getClientDomicile: 'getClientDomicile',
  getCountryManualLookup: 'getCountryManualLookup',
  getMappedCountryManualList: 'getMappedCountryManualList',
  getCountryManualDescriptions: 'getCountryManualDescriptions',
  getCountryManualServiceSuitability: 'getCountryManualServiceSuitability',
  getGridDocumentDetails: 'getGridDocumentDetails',
  getAuthViewDoc: 'getAuthViewDoc',
  exportMediator: 'exportMediator',
  fileByApiTypes: 'fileByApiTypes',
  fileByApiByReportId: 'fileByApiByReportId',
  getSharedRedirect: 'getSharedRedirect',
  getPrivateBankingSourcePdf: 'getPrivateBankingSourcePdf',
  getPrivateBankingDocPermission: 'getPrivateBankingDocPermission',
  getProductDocumentPermission: 'getProductDocumentPermission',
  getLeiSearchAgentJurisdictions: 'getLeiSearchAgentJurisdictions',
  getDownloadViewDoc: 'getDownloadViewDoc',
};
